import { HttpInterceptorFn, HttpErrorResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { catchError, throwError } from 'rxjs';

/**
 * HTTP Interceptor to handle 402 Payment Required errors
 * Automatically displays error messages in a snackbar when users attempt actions
 * that exceed their subscription plan limits
 */
export const paymentErrorInterceptor: HttpInterceptorFn = (req, next) => {
  const snackBar = inject(MatSnackBar);

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      // Check if this is a 402 Payment Required error
      if (error.status === 402) {
        // Extract the error message from the response
        // The backend returns the message as a string in the error body
        let errorMessage = 'This action exceeds your subscription plan limits.';
        
        if (typeof error.error === 'string' && error.error.trim() !== '') {
          errorMessage = error.error;
        } else if (error.error?.message) {
          errorMessage = error.error.message;
        } else if (error.statusText && error.statusText !== 'Unknown Error') {
          // Fallback to statusText for text responses that failed to parse
          errorMessage = error.statusText;
        }

        // Display the error in a snackbar
        snackBar.open(errorMessage, '×', {
          duration: 6000,
          horizontalPosition: 'center',
          verticalPosition: 'top',
          panelClass: ['error-snackbar']
        });
      }

      // Re-throw the error so it can be handled by the service's error handler if needed
      return throwError(() => error);
    })
  );
};
